import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { EventCategoryCreateInput, EventCategoryDto, EventCategoryUpdateInput } from '@upme/contracts';
import { api } from '../../app/api-client';
import { eventCategoriesKey, eventCategoryByIdOptions } from './queries';

export function useCreateEventCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: EventCategoryCreateInput) =>
      api.post('admin/event-categories', { json: body }).json<EventCategoryDto>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...eventCategoriesKey] }),
  });
}

export function useUpdateEventCategory(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: EventCategoryUpdateInput) =>
      api.patch(`admin/event-categories/${id}`, { json: body }).json<EventCategoryDto>(),
    onSuccess: (data) => {
      qc.setQueryData(eventCategoryByIdOptions(id).queryKey, data);
      qc.invalidateQueries({ queryKey: [...eventCategoriesKey] });
    },
  });
}

export function useDeleteEventCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`admin/event-categories/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...eventCategoriesKey] }),
  });
}
